// extracted by mini-css-extract-plugin
export default {"container":"ImageReport_container__gQxAU","frame":"ImageReport_frame__-jBIt","image":"ImageReport_image__iBArn"};